import { CUSTOMER_SEGMENTATION } from '../../constants/api-constants';
import httpClient from '../../utils/http-client';

let config = {
  baseURL: CUSTOMER_SEGMENTATION.baseUrl,
};

export const createUserGroup = (shopId: string, params: any) => {
	return httpClient.post(
		CUSTOMER_SEGMENTATION.api.CREATE_USER_GROUP.replace('$shopId', shopId),
		params,
		config
	);
};

export const getUserGroups = (shopId: any) => {
	return httpClient.get(
		CUSTOMER_SEGMENTATION.api.GET_USER_GROUPS.replace('$shopId', shopId),
		config
	);
};

export const getAllSegment = (shopId: any) => {
	return httpClient.get(
		CUSTOMER_SEGMENTATION.api.GET_ALL_SEGMENT.replace('$shopId', shopId),
		config
	);
};

export const editUserGroup = (shopId: string, id: any, params: any) => {
	return httpClient.put(
		CUSTOMER_SEGMENTATION.api.EDIT_USER_GROUP.replace('$shopId', shopId).replace("$groupId", id),
		params,
		config
	);
};

export const deleteUserGroup = (shopId: string, id: any) => {
	return httpClient.delete(
		CUSTOMER_SEGMENTATION.api.DELETE_USER_GROUP.replace('$shopId', shopId).replace("$groupId", id),
	);
};

export const downloadCustomerGroup = (shopId: string, id: any) => {
	return httpClient.get(
		CUSTOMER_SEGMENTATION.api.DOWNLOAD_CUSTOMER_GROUP.replace('$shopId', shopId).replace("$groupId", id),
	);
};


